import Vue from "vue";
import Router from "vue-router";
import Base from "@/student/layouts/Base";
import Clean from "@/student/layouts/Clean";
import Store from "./store/store"
Vue.use(Router);
import StudentHome from "./pages/home/Home"
import PageNotFound from "@/common/components/PageNotFound.vue";
import ShowCycle from "@/student/pages/cycle/ShowCycle";
import Challenge from "@/student/pages/challenge/Index";
import PendingConfirmation from "@/student/pages/PendingConfirmation";
import SelectModule from "@/student/pages/module/SelectModule";
import CalendarPage from "@/student/pages/calendar/Index";
import MetricsIndexPage from "@/student/pages/metric/Index";
import { selectModulesRouteName, studyNowRouteName, calendarRouteName, homeRouteName, showModuleRouteName, pendingPlanRouteName } from "./constants/routes";
import Login from "@/common/pages/Login.vue";


import startSessionRequests from "./utils/startSessionRequests.js";
import ShowModule from "./pages/module/ShowModulePage.vue";
import navigationGuard from "./utils/navigationGuard";

const router = new Router({
    mode: "history",
    routes: [
      {
        path: "/",
        redirect: '/aluno'
      },
      {
        path: "/admin/login",
        component: Login,
        name: 'login',
      },
      {
        path: "/",
        component: Clean,
        children: [
            {
                path: "/aluno",
                component: StudentHome,
                name: homeRouteName,
            },
            {   
                path: "/confirmacao-pendente",
                component: PendingConfirmation,
                name: pendingPlanRouteName,
            },
        ]
      },
      {
        path: "/aluno",
        component: Base,
        children: [
            {
                path: "modulo/:module_id",
                component: ShowModule,
                name: showModuleRouteName,
            },
            {
                path: "relatorios",
                component: MetricsIndexPage,
                name: "student.metric.index",
            },
            {
                path: "ciclo/",
                component: ShowCycle,
                name: studyNowRouteName,
            },
            
            {
                path: "modulos/selecionar",
                component: SelectModule,
                name: selectModulesRouteName,
            },
            {
                path: "calendario/",
                component: CalendarPage,
                name: calendarRouteName,
            },
            {
                path: "desafio/:challenge_id",
                component: Challenge,
                name: 'challenge.index',
            },
            {
                path: "*",
                component: PageNotFound,
            },
            
        ],
        
    },
 ],
    
});

router.beforeEach((to, from, next) => {

    /*AO ENTRAR NA ROTA SE O USUÁRIO NÃO ESTIVER SETADO TENTA PEGAR O USUÁRIO LOGADO*/
    if (!Store.state.auth.user && to.name != 'login') {
        Store.dispatch('isLoading');
        startSessionRequests()
           .then(() => navigationGuard({ to, next }))
            .catch(() => {
              next({name:'login'});
            })
            .finally(() => Store.dispatch( 'isLoading', false ));
    } else {
        navigationGuard({ to, next })
    }
});

export default router;
